var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainlayout"},[_c('div',{staticClass:"mainlayout-content login-frieze"},[_c('router-view')],1),_c('div',{staticClass:"mainlayout-footer"})])}
var staticRenderFns = []

export { render, staticRenderFns }